@if (Subsets.length > 0) {
  <div class="control">
    <div class="select">
      <select name="Subset" [(ngModel)]="Subset">
        <option value="">All</option>
        @for (s of Subsets; track s) {
          <option [value]="s">
            {{formatSubset(s)}}
          </option>
        }
      </select>
    </div>
  </div>
}